export default __webpack_public_path__ + "static/media/addAddress.aa0c0856.svg";